// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1rxQ7","choiceBoxes":"toolbarselects_choiceBoxes__3UvK3","simpleField":"toolbarselects_simpleField__10_Q7"};